<template>
  <div class="w-full" v-if="fullScreen">
    <main
      class="flex flex-row rounded-md relative fullscreen"
      id="streaming-content"
    >
      <background-content
        :narrative="narrative"
        :key="updates + 1"
      ></background-content>

      <div class="fullscreen w-full" id="streamCanvas" ref="streamCanvas">
        <scrollable-content
          :narrative="narrative"
          :key="updates"
          v-on:ready="reset"
          :debugMode="debugMode"
        ></scrollable-content>
      </div>
    </main>
  </div>
  <div class="ml-4 w-full" v-else>
    <main
      class="flex flex-row rounded-md relative border border-blue-500 preview"
      id="streaming-content"
    >
      <background-content
        :narrative="narrative"
        :key="updates + 1"
      ></background-content>

      <div class="preview w-full" id="streamCanvas" ref="streamCanvas">
        <scrollable-content
          :narrative="narrative"
          :key="updates"
          v-on:ready="reset"
          :debugMode="debugMode"
        ></scrollable-content>
      </div>
    </main>
  </div>
</template>

<script>
// import Component from "../component_location"
var NarrativeController = require("./js/NarrativeController.js");
import BackgroundContent from "@/views/Narratives/BackgroundContent";
import ScrollableContent from "@/views/Narratives/ScrollableContent";
import { EventBus } from "@/utils.js";

export default {
  components: { BackgroundContent, ScrollableContent },

  props: {
    narrative: { type: Object, default: () => {} },
    debugMode: { type: Boolean, default: true },
    fullScreen: { type: Boolean, default: false },
  },

  data() {
    return {
      controller: null,
      updates: 0,
    };
  },

  watch: {
    narrative: {
      // When we update the narrative, rebuild the narrative stream.
      deep: true,
      handler() {
        setTimeout(this.rebuild, 500);
      },
    },
    debugMode() {
      this.rebuild();
    },
  },

  methods: {
    createController() {
      // This generates the narrative...
      if (this.controller) {
        this.controller.reset();
      }
      this.controller = new NarrativeController({
        targetRef: this.$refs.streamCanvas,
        scrollmagic: this.$scrollmagic,
        narrative: this.narrative,
        debugMode: this.debugMode,
      });
    },

    scrollToElement(element) {
      var elementTrigger = document.getElementById(element.Oid + "-trigger");
      this.controller.targetRef.$scrollmagic.scrollTo(elementTrigger);
    },

    rebuild() {
      // Resets the controller and triggers refresh of scrollable content.
      // let myguy = document.getElementById("changer");
      // this.$refs.streamCanvas.$scrollmagic.scrollTo(myguy);
      this.controller.reset();
      this.updates += 1;
    },

    reset() {
      this.createController();
      this.controller.create();
    },
  },

  computed: {},

  mounted() {
    EventBus.$on("scroll-to-element", this.scrollToElement);
  },
};
</script>

<style>
.preview {
  overflow: scroll;
  overflow-x: hidden;
  height: 600px;
}
.fullscreen {
  overflow: scroll;
  overflow-x: hidden;
  height: 100vh;
}
</style>
